import { Store } from "vuex"
import { computed, ComputedRef } from "vue"
import {
  Client,
  GroupMember,
  Level,
  CurrentMember,
  ClientAbility,
} from "suus-api"
import { fetchGroupMemberByCurrentMember } from "features/member/member.functions"

export type OrgLevel = { type: "Client" | "Level"; value: Client | Level }

export default class MemberService {
  constructor(private store: Store<any>) {}

  public currentMember: ComputedRef<CurrentMember> = computed(
    () => this.store.state.member.currentMember?.data
  )

  currentAdhAddress: ComputedRef<string> = computed(() => {
    return this.currentMember.value?.client?.client_address_without_name
  })

  // TODO: The current members should be cached globally, it is a heavy request
  getCurrentGroupMember(): Promise<GroupMember | undefined> {
    return fetchGroupMemberByCurrentMember(this.currentMember.value)
  }

  memberScope: ComputedRef<OrgLevel[]> = computed(() => {
    const memberLevels = this.currentMember.value?.levels || []
    return [
      { type: "Client", value: this.currentMember.value?.client },
      ...(memberLevels.map((level) => ({
        type: "Level",
        value: level,
      })) as OrgLevel[]),
    ]
  })

  groupMemberships: ComputedRef<number[]> = computed(() => {
    return this.currentMember.value?.group_memberships || []
  })

  canUrgentDigestOnClient: ComputedRef<boolean> = computed(() => {
    if (this.currentMember.value) {
      return this.currentMember.value.client_permissions.includes(
        ClientAbility.SendUrgentDigest
      )
    }
    return false
  })
}
